import { supabase } from "../../services/supabase";

export const RUTA_CREAR_CONTRASENA = "/crear-contrasena";
export const LARGO_MINIMO_PASSWORD = 8;
const SIN_ACCESO = "Tu cuenta no tiene acceso. Pide ayuda a un administrador.";

// Mensajes de Supabase Auth en palabras de la iglesia.
function mensajeDeAuth(error) {
  const texto = error?.message || "";
  if (/invalid login credentials/i.test(texto)) return "Correo o contraseña incorrectos";
  if (/email not confirmed/i.test(texto)) return "Aún no has creado tu contraseña: usa el enlace que te llegó al correo.";
  if (/banned/i.test(texto)) return "Tu cuenta está desactivada. Pide ayuda a un administrador.";
  if (/rate limit|too many/i.test(texto)) return "Demasiados intentos. Espera unos minutos e inténtalo de nuevo.";
  if (/should be different/i.test(texto)) return "La nueva contraseña debe ser distinta de la anterior.";
  if (/fetch|network/i.test(texto)) return "No hay conexión. Revisa tu internet e inténtalo de nuevo.";
  return texto || "Ocurrió un error. Inténtalo de nuevo.";
}

// El usuario de la app a partir de rpc('mi_acceso'), con la forma que ya usan las pantallas.
export function aUsuario(datos) {
  return {
    id: datos.usuario_id,
    username: datos.email,
    miembro_id: datos.miembro_id,
    miembro: { id: datos.miembro_id, nombres: datos.nombres, apellidos: datos.apellidos, email: datos.email },
    rol: datos.rol,
    acceso: datos.acceso,
    // Invitada solo con el correo: escribe sus nombres antes de entrar (CompletarDatos).
    datos_pendientes: Boolean(datos.datos_pendientes),
    origen: "supabase",
  };
}

export async function completarDatos(nombres, apellidos, celular) {
  const { data, error } = await supabase.rpc("completar_mis_datos", {
    p_nombres: nombres, p_apellidos: apellidos, p_celular: celular,
  });
  if (error) throw new Error(error.message || "No se pudieron guardar tus datos");
  return aUsuario(data);
}

// Permisos vigentes de quien tiene la sesión abierta, o null si no tiene una cuenta activa.
export async function cargarUsuario() {
  const { data, error } = await supabase.rpc("mi_acceso");
  if (error) throw new Error(mensajeDeAuth(error));
  return data ? aUsuario(data) : null;
}

export async function iniciarSesion(email, password) {
  const { error } = await supabase.auth.signInWithPassword({ email: email.trim().toLowerCase(), password });
  if (error) throw new Error(mensajeDeAuth(error));
  const usuario = await cargarUsuario();
  if (!usuario) {
    await supabase.auth.signOut();
    throw new Error(SIN_ACCESO);
  }
  return usuario;
}

// "¿Primera vez o olvidaste tu contraseña?": la función responde igual exista o no la cuenta.
export async function pedirEnlace(email) {
  const { error } = await supabase.functions.invoke("enviar-enlace", {
    body: { email: email.trim().toLowerCase(), redirect: `${window.location.origin}${RUTA_CREAR_CONTRASENA}` },
  });
  if (error) throw new Error("No se pudo enviar el enlace. Inténtalo de nuevo en un momento.");
}

export function validarNueva(nueva, repetir) {
  if (nueva.length < LARGO_MINIMO_PASSWORD) return `La contraseña debe tener al menos ${LARGO_MINIMO_PASSWORD} caracteres.`;
  if (nueva !== repetir) return "Las contraseñas no coinciden.";
  return "";
}

// Crear la contraseña desde el enlace del correo (la sesión ya viene en el enlace).
export async function crearContrasena(nueva) {
  const { error } = await supabase.auth.updateUser({ password: nueva });
  if (error) throw new Error(mensajeDeAuth(error));
  const usuario = await cargarUsuario();
  if (!usuario) throw new Error(SIN_ACCESO);
  return usuario;
}

// Cambiar la contraseña con la sesión abierta: primero se confirma la actual.
export async function cambiarContrasena(actual, nueva) {
  const { data } = await supabase.auth.getUser();
  const email = data?.user?.email;
  if (!email) throw new Error("Tu sesión venció. Entra de nuevo.");
  const { error: errorActual } = await supabase.auth.signInWithPassword({ email, password: actual });
  if (errorActual) throw new Error("La contraseña actual no es correcta");
  const { error } = await supabase.auth.updateUser({ password: nueva });
  if (error) throw new Error(mensajeDeAuth(error));
}

export async function hayEnlaceValido() {
  const { data } = await supabase.auth.getSession();
  return Boolean(data?.session);
}

export async function salir() {
  await supabase.auth.signOut().catch(() => {});
}

export function alCambiarSesion(funcion) {
  const { data } = supabase.auth.onAuthStateChange(funcion);
  return () => data.subscription.unsubscribe();
}
